'use client'
import { get } from '@partment/client'
import { GET_ACCOUNT_ROLES_QUERY_KEY, IAccountRole } from '@partment/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { v3Path } from '../../api/versionedPath'

type AccountRolesResponse =
  | ReadonlyArray<IAccountRole>
  | { data?: ReadonlyArray<IAccountRole> }

type PersonaAddPopupResult = {
  accountRoles: ReadonlyArray<IAccountRole>
  isLoading: boolean
}

const isAccountRolesEnvelope = (
  value: AccountRolesResponse | undefined,
): value is { data?: ReadonlyArray<IAccountRole> } => {
  return Boolean(value) && !Array.isArray(value)
}

export const getAccountRoles = async (): Promise<AccountRolesResponse> => {
  return get(v3Path('reference/account-roles/')) as unknown as Promise<
    AccountRolesResponse
  >
}

export const usePersonaAddPopup = (enabled = true): PersonaAddPopupResult => {
  const { data: session, status } = useSession()

  const { data: accountRolesResponse, isLoading } = useQuery({
    queryKey: [GET_ACCOUNT_ROLES_QUERY_KEY],
    queryFn: getAccountRoles,
    enabled:
      enabled && status === 'authenticated' && Boolean(session?.access_token),
    retry: false,
  })

  const accountRoles: ReadonlyArray<IAccountRole> = Array.isArray(accountRolesResponse)
    ? accountRolesResponse
    : isAccountRolesEnvelope(accountRolesResponse) &&
        Array.isArray(accountRolesResponse.data)
      ? accountRolesResponse.data
      : []

  return {
    accountRoles,
    isLoading: enabled && (status === 'loading' || isLoading),
  }
}
